module.exports = __webpack_public_path__ + "static/media/53320013_2452979161443927_4486584027800666112_o.a18dad43.jpg";